import React from 'react';

import Informaticacloud from '../images/informatica-powercenter-architecture-components-benefits-removebg-preview.png';
const InformaticaCloud = () => {
  return (
    <div className="informatica-cloud-service">
      <section className="quantum-migration-showcase">
        <div className="nexus-quantum-container">
          <div className="nexus-hero-content">
            <div className="hero-text">
              <h1>Informatica Enterprise Cloud</h1>
              <p className="salesforce-hero-subtitle">
                Accelerate your cloud data integration with our expert Informatica Cloud services
              </p>
            </div>
          </div>
        </div>
        <div className="salesforce-hero-gradient"></div>
      </section>

      <section className="data-power-platform">
        <div className="container">
          <h2 className="title-reveal">Unlock the Power of Your Data</h2>
          <p className="subtitle-float">
            Harness our cloud data expertise to transform information into insight - 
            with intelligent integration, quality assurance, and real-time analytics.
          </p>
          
          <div className="platform-features">
            <div className="platformfeature feature-card-1">
              <div className="feature-icon">
                <div className="icon-bg-circle"></div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
                </svg>
              </div>
              <h3 className="api-ecosystem-title">Unified Data Integration</h3>
              <p className="api-ecosystem-description">Bridge all your systems effortlessly with our cloud-native platform</p>
              <div className="feature-underline"></div>
            </div>
            
            <div className="platformfeature feature-card-2">
              <div className="feature-icon">
                <div className="icon-bg-circle"></div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3 className="api-ecosystem-title">Intelligent Data Quality</h3>
              <p className="api-ecosystem-description">Automated cleansing and governance for trustworthy analytics</p>
              <div className="feature-underline"></div>
            </div>
            
            <div className="platformfeature feature-card-3">
              <div className="feature-icon">
                <div className="icon-bg-circle"></div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 14h16M4 20h16M4 8h16M8 4v4m4-4v4m4-4v4"></path>
                </svg>
              </div>
              <h3 className="api-ecosystem-title">Seamless API Ecosystem</h3>
              <p className="api-ecosystem-description">Connect and manage all your data services in one place</p>
              <div className="feature-underline"></div>
            </div>
          </div>
        </div>
      </section>

    
      <section class="abstract-benefits-section">
  <div class="abstract-container">
 
    <div class="content-column">
      <h2 class="kinetic-title">
        <span class="title-line">Transformative</span>
        <span class="title-line">Benefits</span>
      </h2>
      
      <div class="benefits-list">
      
        <div class="benefit-item">
          <div class="text-block">
            <h3 class="benefit-heading">
              <span class="highlight-marker"></span>
              <span class="text"> Faster Implementation</span>
            </h3>
            <p class="benefit-description">Pre-built connectors reduce setup time dramatically</p>
          </div>
          <div class="animated-underline"></div>
        </div>
        
      
        <div class="benefit-item">
          <div class="text-block">
            <h3 class="benefit-heading">
              <span class="highlight-marker"></span>
              <span class="text"> Cost Reduction</span>
            </h3>
            <p class="benefit-description">Cloud-native solutions lower total ownership costs</p>
          </div>
          <div class="animated-underline"></div>
        </div>
        
     
        {/* <div class="benefit-item">
          <div class="text-block">
            <h3 class="benefit-heading">
              <span class="highlight-marker"></span>
              <span class="text">Elastic Scalability</span>
            </h3>
            <p class="benefit-description">Architecture grows seamlessly with your business</p>
          </div>
          <div class="animated-underline"></div>
        </div> */}
        
     
        <div class="benefit-item" >
          <div class="text-block">
            <h3 class="benefit-heading">
              <span class="highlight-marker"></span>
              <span class="text">Enterprise Security</span>
            </h3>
            <p class="benefit-description">Built-in compliance and data protection features</p>
          </div>
          <div class="animated-underline"></div>
        </div>
      </div>
    </div>
    
   
    <div class="image-column">
      <div class="image-composition">
     
        <div class="image-wrapper">
         
             <img src={Informaticacloud} alt="ServiceNow Migration Process" className="sn-feature-image1" />

        
        </div>

        <div class="floating-shape shape-1"></div>
        <div class="floating-shape shape-2"></div>
        <div class="floating-shape shape-3"></div>
        
   
        <div class="grid-overlay"></div>
      </div>
    </div>
  </div>
  

  <div class="background-elements">
    <div class="bg-shape bg-shape-1"></div>
    <div class="bg-shape bg-shape-2"></div>
  </div>
</section>
<section class="pbs-solutions-section">
        <div class="pbs-container">
            <div class="pbs-section-header">
                <h2 class="pbs-section-title">Why Choose Our Solutions</h2>
                <p class="pbs-section-subtitle">Streamline your business operations with our proven methodologies and cutting-edge technology solutions</p>
            </div>
            
            <div class="pbs-benefits-grid">
                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">Increased Efficiency</h3>
                    <p class="pbs-benefit-description">Automate repetitive tasks and optimize workflows to boost productivity across your organization</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">85%</span>
                        <span>productivity increase</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill" ></div>
                    </div> */}
                </div>
                
                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">Cost Reduction</h3>
                    <p class="pbs-benefit-description">Eliminate unnecessary expenses and optimize resource allocation for maximum ROI</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">40%</span>
                        <span>cost savings</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill" ></div>
                    </div> */}
                </div>
                
                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12,3L2,12H5V20H19V12H22L12,3M12,7.7L17,12.7V18H15V14H9V18H7V12.7L12,7.7Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">Scalable Growth</h3>
                    <p class="pbs-benefit-description">Built to grow with your business, from startup to enterprise-level operations</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">300%</span>
                        <span>scalability potential</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill"></div>
                    </div> */}
                </div>
                
                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10.5V11A1,1 0 0,1 14,12H10A1,1 0 0,1 9,11V10.5C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,8.7 10.2,10.5V10.8H13.8V10.5C13.8,8.7 12.8,8.2 12,8.2Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">Enhanced Security</h3>
                    <p class="pbs-benefit-description">Enterprise-grade security measures to protect your data and ensure compliance</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">99.9%</span>
                        <span>uptime guarantee</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill"></div>
                    </div> */}
                </div>

                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M16.59,7.58L10,14.17L7.41,11.59L6,13L10,17L18,9L16.59,7.58Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">Quality Assurance</h3>
                    <p class="pbs-benefit-description">Rigorous testing and quality control processes to ensure flawless delivery</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">98%</span>
                        <span>client satisfaction</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill" ></div>
                    </div> */}
                </div>

                <div class="pbs-benefit-card pbs-fade-in">
                    <div class="pbs-benefit-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A2.5,2.5 0 0,0 5,15.5A2.5,2.5 0 0,0 7.5,18A2.5,2.5 0 0,0 10,15.5A2.5,2.5 0 0,0 7.5,13M16.5,13A2.5,2.5 0 0,0 14,15.5A2.5,2.5 0 0,0 16.5,18A2.5,2.5 0 0,0 19,15.5A2.5,2.5 0 0,0 16.5,13Z"/>
                        </svg>
                    </div>
                    <h3 class="pbs-benefit-title">24/7 Support</h3>
                    <p class="pbs-benefit-description">Round-the-clock technical support and customer service to keep you running smoothly</p>
                    <div class="pbs-benefit-metric">
                        <span class="pbs-metric-value">24/7</span>
                        <span>support availability</span>
                    </div>
                    {/* <div class="pbs-stats-bar">
                        <div class="pbs-stats-fill" ></div>
                    </div> */}
                </div>
            </div>
        </div>
    </section>

      <section className="informatica-cta">
        <div className="container">
          <h2>Ready to optimize your cloud data strategy?</h2>
          <p>Our Informatica Cloud specialists can help you design and implement the perfect solution.</p>
          <button className="cta-button">Contact Our Experts</button>
        </div>
      </section>
    </div>
  );
};

export default InformaticaCloud;